// extracted by mini-css-extract-plugin
export var header = "layout-module--header--6a868";
export var main = "layout-module--main--6b2f2";
export var nav = "layout-module--nav--dad1f";
export var root = "layout-module--root--e288a";
export var sidebar = "layout-module--sidebar--7a6df";
export var sidebarInner = "layout-module--sidebarInner--e5a4c";
export var sidebarScroll = "layout-module--sidebarScroll--ba938";